export default [
  {
    name: {
      it: 'Education',
      en: 'Education'
    },
    list: [
      { title: { it: 'Studenti e famiglie', en: 'Students and families' } },
      { title: { it: 'Scuole e università', en: 'Schools and universities' } },
      { title: { it: 'Ministero e USR', en: 'Ministry of Education' } },
      { title: { en: 'Ministry of Education Regional Office' } },
      { title: { it: 'Amministrazioni locali', en: 'Local administrations' } },
      { title: { it: 'Imprese e terzo settore', en: 'Companies and third sector' } }
    ],
    images: ['/images/about/who/STAKEHOLDERS1_1280X1280_RoboAbaco-63.jpg']
  },
  {
    name: {
      it: 'Innovazione e territorio',
      en: 'Innovation and local territory'
    },
    list: [
      { title: { it: 'Scuole e università', en: 'Schools and universities' } },
      { title: { it: 'Amministrazioni locali', en: 'Local administrations' } },
      { title: { it: 'Reti dell’innovazione', en: 'Innovation networks' } },
      { title: { it: 'Start-up', en: 'Start-ups' } },
      { title: { it: 'Imprese e terzo settore', en: 'Companies and third sector' } }
    ],
    images: ['/images/about/who/STAKEHOLDERS2_1280X1280_Fermi_esterni-32.jpg']
  },
  {
    name: {
      it: 'Solidarietà sociale',
      en: 'Social solidarity'
    },
    list: [
      { title: { it: 'Soggetti bisognosi', en: 'Individuals in need' } },
      { title: { it: 'Enti assistenziali nazionali', en: 'National welfare organisations' } },
      { title: { it: 'Enti assistenziali locali', en: 'Local welfare organisations' } }
    ],
    images: ['/images/about/who/STAKEHOLDERS3_1280X1280_Fondazione-Faro.jpg']
  }
];
